import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../utils/api.services";
import { setLoader } from "./MasterSlice";

export const getUsersData = createAsyncThunk("userlist", async (pageChangeData, { dispatch }) => {
    try {
        dispatch(setLoader(true));
        let { data: userData } = await API.getUserList(pageChangeData);
       
        console.log('userData redux me +++++++++-----------------------', userData);
        return userData;
    } catch (error) {
     
        throw error;
    }
});


export const getContractorData = createAsyncThunk("contractorlist", async (pageChangeData, { dispatch }) => {
    try {
        dispatch(setLoader(true));
        let { data: userData } = await API.getContractorList(pageChangeData);
       
        console.log('userData redux me +++++++++-----------------------', userData);
        return userData;
    } catch (error) {
     
        throw error;
    }
});

const initialState = {
    userList: {
        data: [],
        error: null,
    },
};


const userSlice = createSlice({
    name: "USER",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUsersData.fulfilled, (state, action) => {
                state.userList.data = action.payload;
            })
            .addCase(getUsersData.rejected, (state, action) => {
                state.userList.error = action.error.message;
            })
    },
});


export default userSlice.reducer;
